import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { copyQuizset } from '@/api/gen/quiz/quiz.gen';

/**
 * 타인 퀴즈를 내 퀴즈로 **즉시** 복사한다 (`POST /quizsets/{sourceQuizsetId}/copy`).
 *
 * 빌드 페이지를 거치지 않는다 — 제목·맵·문항·원작자·플랜 정보를 클라이언트가 조립해 보내지
 * 않고 서버가 원본을 읽는다. 복사와 폴더 배정이 한 요청이라 성공 후 담기 요청을 또 보내지
 * 않는다.
 *
 * `folderId` 를 생략하면 폴더 없는 기본 내 퀴즈 자리에 저장된다(body 는 `{}` 로 보낸다).
 * 응답의 `id` 가 **새 퀴즈 ID** 다 — 원본 ID 로 상세 이동·캐시 갱신을 하면 안 된다.
 * 잠금 여부도 응답의 `isLocked` 를 쓴다(원본 잠금으로 추정 금지).
 *
 * 공개 여부·공개 확인값은 **보내지 않는다.** 복사본은 서버가 항상 공개로 만들고(목적지 폴더의
 * 공개 여부와 무관), 원본이 공개될 일이 없어 확인 계약도 없다. 그래서 요청 필드는 `folderId` 뿐이다.
 */
export const copyQuizToLocation = async ({
  sourceQuizsetId,
  folderId,
}: {
  sourceQuizsetId: string;
  folderId?: string;
}): Promise<QuizSetDetailsRes> =>
  (await copyQuizset(sourceQuizsetId, { folderId })).data;
